// extracted by mini-css-extract-plugin
export default {"container":"style_container__LqW+o","dot":"style_dot__QYqig","text":"style_text__9wHQR"};